import { GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { TALK_TO_SALES } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
export const getPurchaseMotionEligibility = (apiName, upgradeModalPurchaseMotions) => {
  if (!apiName || apiName === GENERAL || !upgradeModalPurchaseMotions || !upgradeModalPurchaseMotions[apiName]) {
    return [TALK_TO_SALES];
  }
  const purchaseMotionKeys = upgradeModalPurchaseMotions[apiName] || [];
  return purchaseMotionKeys.map(purchaseMotion => purchaseMotion.key);
};